<div #actionCellRenderer class="d-flex justify-content-end">
  @for (action of actions; track action) {
    <span class="icon-container-margin">
      @if (!isBootstrapIcon(actionToClassMap[action])) {
        <span
          class="material-symbols-sharp icon-size cursor-select"
          (click)="actionClicked(action, $event)"
          name="popover"
          data-bs-placement="top"
          [attr.data-bs-content]="TooltipMap[action]"
        >
          {{ actionToClassMap[action] }}
        </span>
      }
      @if (isBootstrapIcon(actionToClassMap[action])) {
        <i
          class="icon-size cursor-select"
          (click)="actionClicked(action, $event)"
          [ngClass]="actionToClassMap[action]"
          name="popover"
          data-bs-placement="top"
          [attr.data-bs-content]="TooltipMap[action]"
        >
        </i>
      }
    </span>
  }
</div>
